import { ComponentProps } from "react";
import { Link } from "@tanstack/react-router";

export const linkComponents = {
  a: ({ href, ...props }: ComponentProps<"a">) => {
    const isExternal = href?.startsWith("http");
    return isExternal ? (
      <a {...props} href={href} target="_blank" rel="noopener noreferrer" />
    ) : (
      <Link
        {...props}
        to={href || ""}
        target="_blank"
        rel="noopener noreferrer"
      />
    );
  },
};
